import * as Yup from "yup";
import { tr } from "yup-locales";
if (process.env.NEXT_PUBLIC_LANGUAGE !== "en") Yup.setLocale(tr); // en: Yup varsayilan (Ingilizce) mesajlari

export const ReservationShema = Yup.object().shape({
  name: Yup.string().required().min(2),
  email: Yup.string().required().email(),
  phoneIsValid: Yup.boolean().isTrue(),
  phoneIsValid2: Yup.boolean(),
  // identityNumber: Yup.string().required(),
  firstPayment: Yup.number(),
  paymentMethod: Yup.number(),
  sozlesme: Yup.boolean().isTrue(),
  kvkk: Yup.boolean().isTrue(),
});
